import { React, Fragment, useEffect, useState } from 'react';
import { usePageSettingStore } from '../../home/stores';
import { Menu, Transition } from '@headlessui/react';
import img from '../img/ubaform-logo.svg';
import { Link, useHistory, useLocation, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import decode from 'jwt-decode';
import { isAuth, logout } from '../../auth/actions';

export function Header() {
  const [, actionsPageSetting] = usePageSettingStore();

  const handleChangeMode = async () => {
    actionsPageSetting.changeMode();
  };
  const getInitials = function (string) {
    var names = string ? string.split(' ') : '',
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };

  const history = useHistory()

  return (
    <header className='w-screen top-bar'>
      <button
        type='button'
        className='menu-toggler la la-bars'
        onClick={() => handleChangeMode()}
        data-toggle='menu'
      ></button>

      <img alt='nadi' className='brand' src={img} width='160px' />
      <div className='flex items-center ml-auto'>
        <Menu as='div' className='dropdown'>
          {({ open }) => (
            <>
              <Menu.Button className='flex items-center ml-4 text-gray-700'>
                <span className='avatar'>
                  {isAuth().name ? getInitials(isAuth().name) : ''}
                </span>
              </Menu.Button>
              <Transition
                show={open}
                as={Fragment}
                enter='transition ease-out duration-100'
                enterFrom='transform opacity-0 scale-95'
                enterTo='transform opacity-100 scale-100'
                leave='transition ease-in duration-75'
                leaveFrom='transform opacity-100 scale-100'
                leaveTo='transform opacity-0 scale-95'
              >
                <Menu.Items
                  static
                  className='w-64 origin-top-right absolute right-2 mt-2  rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none'
                >
                  <div className='p-5'>
                    <h5 className='uppercase'>{isAuth().name}</h5>
                    Admin
                  </div>
                  <hr />
                  <div className='p-5'>
                    <Link
                      to='/profile'
                      className='flex items-center text-gray-700 dark:text-gray-500 hover:text-primary dark:hover:text-primary'
                    >
                      <span className='la la-user-circle text-2xl leading-none mr-2'></span>
                      View Profile
                    </Link>
                  </div>
                  <hr />
                  <div className='p-5'>
                    <button
                      onClick={() =>
                        logout(() => history.push('/auth/login'))
                      }
                      type='button'
                      className='flex items-center text-gray-700 dark:text-gray-500 hover:text-primary dark:hover:text-primary'
                    >
                      <span className='la la-power-off text-2xl leading-none mr-2'></span>
                      Logout
                    </button>
                  </div>
                </Menu.Items>
              </Transition>
            </>
          )}
        </Menu>
      </div>
    </header>
  );
}
